import predicates from '../predicates'
import selectors from '../selectors'
import { SYNDICATION_TRAFFIC_SOURCE } from '../constants'

const syndication = {
  rule: predicates.and(
    predicates.pathnameIncludesOne('synd'),
    predicates.searchParamIncludesOne('partner')
  ),
  extractor: traffic => {
    const trafficSource = SYNDICATION_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'partner')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default syndication



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/syndication.js